import React, { useState, useEffect } from 'react';
import { Spinner } from '@themesberg/react-bootstrap';
import MUIDataTable from 'mui-datatables';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import {
  clearAllTransactionsCustomer,
  clearIndividualCustomer,
  getAllTransactionCustomerById,
  getCustomerById,
} from '../../redux/actions/customer';
import CustomErrorView from '../../components/CustomErrorView';
import { tableThemeStatic } from '../../helpers/tableTheme';
import ColorComponent from '../../components/ColorComponent';
import { useHistory, useParams } from 'react-router-dom';
import TableLinkComponent from '../../components/TableLinkComponent';
import { DateFormatter2 } from '../../helpers/DateFormatter2';

function CustomerTransactionDetail({}) {
  const history = useHistory();
  const { id } = useParams();

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [showErrPage, setShowErrPage] = useState();
  // const [customerId, setCustomerId] = useState('');

  const allTransactions = useSelector(
    (state) => state.customer?.allTransactions
  );
  const individualCustomer = useSelector(
    (state) => state.customer?.individualCustomer
  );
  const columns = [
    {
      name: 'Transaction Id',
      label: 'Transaction Id',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'Transaction Date',
      label: 'Transaction Date',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => {
          return <>{DateFormatter2(value)}</>;
        },
      },
    },

    {
      name: 'Transaction Type',
      options: {
        customBodyRender: (value) => {
          return <ColorComponent value={value} />;
        },
      },
    },
    {
      name: 'Amount',
      label: 'Amount',
      options: {
        filter: false,
        sort: true,
      },
    },

    {
      name: 'Batch Id',
      label: 'Batch Id',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => (
          <TableLinkComponent
            value={value}
            onClick={() =>
              history.push(`/transactions/batch/${tableMeta.rowData[4]}`)
            }
          />
        ),
      },
    },
    {
      name: 'Collected Id',
      label: 'Collected Id',
      options: {
        filter: false,
        sort: true,
        display: 'excluded',
      },
    },
    {
      name: 'Collected By',
      label: 'Collected By',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => (
          <TableLinkComponent
            value={value}
            onClick={() =>
              history.push(`/collectors/profile/${tableMeta.rowData[5]}`)
            }
          />
        ),
      },
    },

    {
      name: 'Status',
      options: {
        customBodyRender: (value) => {
          return <ColorComponent value={value} />;
        },
      },
    },
  ];

  useEffect(() => {
    const someId = id;
    if (!someId) {
      setShowErrPage(true);
    } else {
      setIsLoading(true);
      // setCustomerId(someId);
      dispatch(getAllTransactionCustomerById(someId)).then(() =>
        setIsLoading(false)
      );
      dispatch(
        getCustomerById(
          someId,
          () => {},
          () => {}
        )
      );
    }
    return () => {
      dispatch(clearAllTransactionsCustomer());
      dispatch(clearIndividualCustomer());
    };
  }, []);

  const onRowsSelect = (rowData, rowMeta) => {};
  const options = {
    filterType: 'checkbox',
    selectableRowsOnClick: false,
    onRowClick: onRowsSelect,
    responsive: 'standard',
    print: false,
    download: false,
    sortOrder: {
      name: 'Transaction Date',
      direction: 'desc',
    },
    elevation: 0,
  };

  if (showErrPage) {
    return <CustomErrorView />;
  } else {
    return (
      <div>
        <MuiThemeProvider theme={tableThemeStatic}>
          {isLoading ? (
            <div
              className='d-flex justify-content-center align-items-center'
              style={{
                height: '90vh',
              }}
            >
              <Spinner animation='border' />
            </div>
          ) : (
            <MUIDataTable
              title={`All Transactions of ${
                individualCustomer?.accountName ?? ''
              } `}
              data={allTransactions}
              columns={columns}
              options={options}
            />
          )}
        </MuiThemeProvider>
      </div>
    );
  }
}

export default CustomerTransactionDetail;
